import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { BaseComponent, UserService } from "@mypxplat/xplat/core";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "fui-card",
  templateUrl: "card.component.html",
  standalone: false,
})
export class FuiCardComponent extends BaseComponent implements OnInit {
  @Input() text: string;
  @Input() image: string;
  @Input() imageAsBackground: string;
  @Input() title: string;
  @Input() productImage: string;
  @Input() progress: string;
  @Input() imageAspectRatio: string = "16 / 9";
  @Output() imageClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() titleClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() cardClick: EventEmitter<any> = new EventEmitter<any>();

  constructor(userService: UserService) {
    super(userService);
  }

  ngOnInit(): void {}
}
